import { Outlet } from "@tanstack/react-router";

import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Navbar } from "@/components/navbar/Navbar";

export function PrivateLayout() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <main className="mt-16 p-3">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
